import { render, staticRenderFns } from "./NewBusinessContact.vue?vue&type=template&id=15c38a3a&scoped=true&"
import script from "./NewBusinessContact.vue?vue&type=script&lang=js&"
export * from "./NewBusinessContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c38a3a",
  null
  
)

export default component.exports